<template>
  <router-link :to="homeRoute">
    <v-list-item style="display:flex;flex-direction:column;">
      <v-list-item-avatar
        style="margin:50px 0px -5px 0px"
        tile
      >
        <v-img :src="require('@/assets/favicon.svg')" />
      </v-list-item-avatar>
      <v-list-item-content>
        <span style="font-size:43px;font-weight:500;color:black">AccuMAP</span>
      </v-list-item-content>
      <span style="display:flex;justify-content:center;margin-bottom:-20px;margin-top:-14px;font-size:0.8rem;letter-spacing:1px;">v 1.12.7</span>
    </v-list-item>
  </router-link>
</template>
<script>
export default {
  name: 'DefaultDrawerHeader',
  computed: {
    homeRoute() {
      const token = this.$store.getters.getAccessToken;
      if (!token) return '/dashboard';
      
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          }).join("")
        );
        const userData = JSON.parse(jsonPayload);
        
        // Level 4 사용자는 Virus 페이지로 이동
        if (userData.level === 4) {
          return '/virus';
        }
        
        return '/dashboard';
      } catch (error) {
        return '/dashboard';
      }
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none !important;
}
a:hover {
  text-decoration: none !important;
}
ul {
  list-style: none;
}
</style>